module.exports = __webpack_public_path__ + "img/ethiopiaid.decd7d4.png";